import { apiEndpoints } from '@/apiEndpoints';
import { Bill } from '@/types/bills/billColumnDef';
import axios from 'axios';

export const getMyBills = async () => {
  const result = await axios.get<Bill[]>(apiEndpoints.bills.base);
  return result.data;
};
